import React from 'react';
import { useTranslation } from 'react-i18next';
import ExportCSVCustomers from './ExportCSVCustomers';

function ExportCSVRow({ data = [], text }) {
  const [t] = useTranslation();

  if (data.length === 0) return null;
  return (
    <li>
      {text}: {data.length} <ExportCSVCustomers data={data} />
    </li>
  );
}

export default ExportCSVRow;
